export const paths = [{ "tag": "path", "att": { "d": "m11 7.8294-3.242 3.242-1.4143-1.4142L12 4l5.6575 5.6572-1.4143 1.4142L13 7.8284V16h-2V7.8294z" } }, { "tag": "path", "att": { "d": "M2 21.0029h20v-9h-2v7H4v-7H2v9z" } }];
export const iconName = 'arrow-up-from-base';
export const arrowUpFromBase = { iconName, paths };
export default paths;
